export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-pagination@1.17.8@rc-pagination/es/index.js
// module id = 704
// module chunks = 0